import React, { useState } from 'react'
import { IconDeviceFloppy } from '@tabler/icons-react'
import { isFunction, isEmpty } from 'lodash'
import * as Yup from 'yup'

import { customStaticRanges } from '@/components/helpers'
import { AbstractForm } from '@/components/forms/formik/AbstractForm'
import { Button } from '@/components/buttons/Button'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Filter name is required'),
})

export const SaveCallFilter = ({ handleSave, filterDateRangeLabel, filterValuesApplied }) => {
  const [open, setOpen] = useState(false)

  const dateRangeOptions = customStaticRanges.map((staticRange) => {
    return {
      value: staticRange.label.toLowerCase(),
      label: staticRange.label,
    }
  })

  const defaultDateRangeSelected =
    dateRangeOptions.find((option) => option.label === filterDateRangeLabel)?.value || 'today'

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <InteractiveTooltip
      size="large"
      theme="light"
      clickable
      open={open}
      setOpen={setOpen}
      placement="bottom"
      content={
        <div>
          <h3>Save New Filter</h3>
          <p>Create a new saved filter from the currently applied call explorer filters.</p>

          {!isEmpty(filterValuesApplied) ? (
            <div className="mb">
              {filterValuesApplied.map(([accessor, properties]) => (
                <div key={`${accessor}-display`} className="flex-align-center small-gap">
                  <strong>{properties.label}: </strong>
                  <span>
                    {isFunction(properties.format) ? properties.format(accessor) : properties.value}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <p>
              <em>No additional filters have been applied.</em>
            </p>
          )}

          <AbstractForm
            validationSchema={validationSchema}
            schema={[
              {
                name: 'name',
                type: 'text',
                label: 'Filter Name',
                autoFocus: true,
                required: true,
              },
              {
                name: 'isDefault',
                type: 'checkbox',
                label: 'Set as default filter',
              },
              {
                label: 'Date Range',
                name: 'dateRange',
                type: 'select',
                options: dateRangeOptions,
                defaultValue: defaultDateRangeSelected,
                isClearable: false,
              },
            ]}
            onClose={handleClose}
            closeButtonLabel="Cancel"
            buttonLabel="Save New Filter"
            buttonProps={{ small: true }}
            closeButtonProps={{ small: true }}
            onSubmit={(values, { setSubmitting }) => {
              handleSave(values)
              setSubmitting(false)
              handleClose()
            }}
          />
        </div>
      }
    >
      <Button active={open} small data-testid="call-search-save-filter-button">
        <IconDeviceFloppy />
        Save Filter As...
      </Button>
    </InteractiveTooltip>
  )
}
